import { useContext } from "react";
import BreadcrumbContext from "../context/BreadcrumbContext";

export default function useBreadcrumbs() {
	const { breadcrumb, setBreadcrumb } = useContext(BreadcrumbContext);

	return {
		breadcrumb,
		setBreadcrumb,
	};
}
